import { Component, OnInit, Input } from '@angular/core';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';

@Component({
  selector: 'app-colored-options',
  templateUrl: './colored-options.component.html',
  styleUrls: ['./colored-options.component.scss']
})
export class ColoredOptionsComponent implements OnInit {
  @Input()
  statusId: number = null;
  statuses: any[];
  settings: Settings;
  constructor(private appSettings: AppSettings) {
    this.settings = this.appSettings.settings;
  }
  ngOnInit() {
    this.statuses = [
      {
        statusId: 0,
        statusName: 'متوقع',
        statusNameEn: 'EXPECTED',
        color: '#3d1b68'
      },
      {
        statusId: 1,
        statusName: 'قيد التدقيق',
        statusNameEn: 'AUDITING',
        color: '#ff8357'
      },
      {
        statusId: 2,
        statusName: 'تمت الموافقة',
        statusNameEn: 'APPROVAL',
        color: '#86c27c'
      }
    ];
  }
  getBackground(): string {
    const status = this.statuses.find(item => item.statusId === this.statusId);
    return status ? status.color : '#fff';
  }
}
